document.addEventListener('DOMContentLoaded', function () {
  if (!('geolocation' in navigator)) return;

  navigator.geolocation.getCurrentPosition(
    function () {
      console.log('Location permission granted');
    },
    function () {
      console.log('Location permission denied');
    }
  );
});
